import React, { useState, useEffect } from 'react';
import TR from '../../Trans';
import Button from '@mui/material/Button';
import BDialog from './BDialog';
import Grid from '@mui/material/Grid';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import DialogContent from '@mui/material/DialogContent';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import DialogTitle from '@mui/material/DialogTitle';

function SetPinDialog(props) {

  const [pin, setPin] = useState("");

  useEffect(() => {
    setPin("");
  }, [props.open])

  const handleKeyDown = (event) => {  
    if (event.key === 'Enter') {
      props.onSetPin(pin);
    }
  };

  return (
    <BDialog disableRestoreFocus open={props.open} onKeyDown={handleKeyDown} onClose={props.onClose}>
      <DialogTitle>{TR.cm_enter_new_pin}</DialogTitle>
      <DialogContent>
        <InputLabel>{TR.cm_pin}</InputLabel>
        <TextField
          autoFocus
          autoComplete="off"
          margin="dense"
          type="text"
          fullWidth
          onChange={(e) => setPin(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={6} justifyContent="center">
          <Button color="secondary" onClick={props.onClose}>{TR.cm_cancel}</Button>
          <Button
            color="success"
            className="muvika-dialog-action-right"
            onClick={() => props.onSetPin(pin)}>OK</Button>
        </Stack>
      </DialogActions>
    </BDialog>
  );
}

export default SetPinDialog;